<template>
  <div>
    <Layout :pagetitle="$t('Partner Level')">
      <form autocomplete="off" @submit.prevent="savePartnerLevel">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Partner Level') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="3">
              <label>{{ $t('Brand') }}</label>
              <brandSelectorUnique :modelValue="idBrand" @onChange="setBrand" />
            </b-col>
            <b-col md="3">
              <label>{{ $t('Sub Brand') }}</label>
              <subBrandsSelector :mode="'single'" :modelValue="idSubBrand" @onChange="setSubBrand" />
            </b-col>
            <b-col md="3">
              <label>{{ $t('Level') }}</label>
              <b-form-select required v-model="level" @change="idParentLevel = null">
                <option v-text="$t('Level 1')" :value="1" />
                <option v-text="$t('Level 2')" :value="2" />
                <option v-text="$t('Level 3')" :value="3" />
              </b-form-select>
            </b-col>
            <b-col md="3">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="level && !$store.state.isLoading">
            <b-col md="6" v-if="!isLevel3">
              <label>
                {{ $t('Parent Level') }}
                <span> ({{ level + 1 }}) </span>
              </label>
              <partnerLevelSelector :modelValue="idParentLevel" @onChange="setParentLevel" :level="level + 1" />
            </b-col>
            <b-col md="6" v-if="!$route.params.id">
              <b-row>
                <b-col md="6">
                  <label>{{ $t('Partner') }}</label>
                  <partnerSelector
                    v-if="!partnerFormModal"
                    :modelValue="partnerId"
                    @onChange="setPartner"
                    :level="level"
                    :isDisabled="!level"
                  />
                </b-col>
                <b-col>
                  <label class="mt-4 pt-3" />
                  <div class="btn-group mt-2">
                    <button
                      class="btn btn-primary"
                      @click="addPartner"
                      type="button"
                      :disabled="!level || !partnerId"
                    >
                      {{ $t('Select') }}
                    </button>
                    <button
                      class="btn btn-primary"
                      :disabled="!level"
                      @click="partnerFormModal = true"
                      type="button"
                    >
                      <i class="mdi mdi-account-plus" />
                      {{ $t('Register') }}
                    </button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col md="12" v-if="partners.length">
              <Table
                :title="$t('Partners')"
                :items="partnersTable"
                :columns="partnersColumns"
                :totalItems="partners.length"
                :removable="$route.params.id ? false : true"
                :editLabel="$t('View')"
                :editable="true"
                @onRemove="removePartner"
                @onEdit="editPartner"
              />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              :disabled="$store.state.isLoading"
              v-if="!$route.params.id"
            >
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
      <b-modal v-model="partnerFormModal" size="xl" hide-footer hide-header @hide="hidePartnerModal">
        <partnerForm
          v-if="partnerFormModal"
          :partnerLevel="level"
          :partner="partnerEditId"
          :isComponent="true"
          @onSave="savePartner"
        />
      </b-modal>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import partnerLevelSelector from '@/components/selectors/partnerLevelSelector';
import partnerSelector from '@/components/selectors/partnerSelector';
import Table from '@/components/bootstrap/table';
import partnerForm from '../partner/partnerForm.vue';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: {
    Layout,
    brandSelectorUnique,
    partnerLevelSelector,
    partnerSelector,
    Table,
    subBrandsSelector,
    partnerForm
  },
  data() {
    return {
      name: '',
      level: null,
      idBrand: null,
      idParentLevel: null,
      idSubBrand: null,
      partners: [],
      partner: null,
      partnerId: null,
      partnerFormModal: false,
      partnersColumns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'level',
          label: this.$t('Level')
        },
        {
          key: 'token',
          label: 'Token'
        },
        {
          key: 'percentage',
          label: this.$t('Percentage')
        },
        {
          key: 'calculation',
          label: this.$t('Calculation')
        }
      ],
      partnerEditId: null
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getPartnerLevel();
    }
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    hidePartnerModal() {
      this.partnerFormModal = false;
      this.partnerEditId = null;
    },
    editPartner(partner) {
      this.partnerEditId = partner.id;
      this.partnerFormModal = true;
    },
    savePartner(partner = null) {
      let partnerIdx = this.partners.findIndex((p) => p.id == partner.id);

      if (partnerIdx != null) {
        this.partners[partnerIdx] = {
          ...this.partners[partnerIdx],
          ...partner
        };
        this.partnerFormModal = false;
        return;
      }

      this.partners.push(partner);
      this.partnerFormModal = false;
    },
    savePartnerLevel() {
      if (this.isLevel3) {
        this.idParentLevel = null;
      }

      if (this.$route.params?.id) {
        this.updatePartnerLevel();
      } else {
        this.createPartnerLevel();
      }
    },
    getPartnerLevel() {
      const partnerLevelId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/partnerLevel/${partnerLevelId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let partner = res.data;

          this.name = partner.name;
          this.level = partner.level;
          this.idBrand = partner.id_brand;
          this.idSubBrand = partner.id_sub_brand;
          this.partners = partner.partners;
          this.idParentLevel = partner.id_parent_level;
          this.getPartners();
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createPartnerLevel() {
      if (!this.validatePartnerLevel()) return;
      let partner = {
        name: this.name,
        level: this.level,
        idBrand: this.idBrand,
        idSubBrand: this.idSubBrand || null,
        idParentLevel: this.idParentLevel,
        partners: this.partners.map((p) => p.id)
      };

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/partnerLevel', partner)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });

          this.$router.push({
            name: 'partnerLevelList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create partner error')
          });
        });
    },
    updatePartnerLevel() {
      if (!this.validatePartnerLevel()) return;
      let partnerLevelId = this.$route.params.id;
      let partner = {
        name: this.name,
        level: this.level,
        idSubBrand: this.idSubBrand || null,
        idBrand: this.idBrand,
        idParentLevel: this.idParentLevel,
        partners: this.partners.map((p) => p.id)
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/partnerLevel/${partnerLevelId}`, partner)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'partnerLevelList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update partner error')
          });
        });
    },
    setBrand(brand = null) {
      this.idBrand = brand;
    },
    setParentLevel(pl = null) {
      this.idParentLevel = pl;
    },
    setPartner(id = null, partner = {}) {
      this.partner = partner;
      this.partnerId = id;
    },
    addPartner() {
      if (!this.partnerId) {
        this.$customAlert({
          msg: this.$t('Invalid partner'),
          type: 'warning'
        });
        return;
      }
      if (this.partners.find((p) => p.id == this.partnerId)) {
        this.$customAlert({
          msg: this.$t('Partner already selected'),
          type: 'warning'
        });
        return;
      }

      this.$api
        .get(`api/partnerLevel/all?partner=${this.partnerId}&partnerLevel=${this.$route?.params?.id || ''}`)
        .then((res) => {
          if (!res?.data?.length) {
            this.partners.push(this.partner);
            this.partner = null;
            this.partnerId = null;
          } else {
            this.$customAlert({
              msg: this.$t('Partner already associated'),
              type: 'warning'
            });
          }
        });
    },
    removePartner(partner) {
      let index = null;

      this.partners.forEach((p, i) => {
        if (p.id == partner.id) {
          index = i;
        }
      });

      if (index != null) {
        this.$store.commit('SET_LOADING', true);
        this.$api
          .destroy(`api/partner/${partner.id}`)
          .then(() => {
            this.$store.commit('SET_LOADING', false);
            this.partners.splice(index, 1);
          })
          .catch((error) => {
            this.$store.commit('SET_LOADING', false);
            console.error('Failed to delete partner:', error);
          });
      }
    },
    validatePartnerLevel() {
      if (!this.idBrand) {
        this.$customAlert({
          msg: this.$t('Invalid brand'),
          type: 'error'
        });
        return false;
      }
      if (!this.partners?.length) {
        this.$customAlert({
          msg: this.$t('Adicione ao menos um comissionado'),
          type: 'error'
        });
        return false;
      }
      if (this.loggedUser()?.settings?.subBrands?.length) {
        if (!this.idSubBrand) {
          this.$customAlert({
            msg: this.$t('Invalid sub brand'),
            type: 'error'
          });
          return false;
        }
      }
      return true;
    },
    getPartners() {
      let partners = this.partners;

      if (partners.length) {
        this.$api.get('api/partner/all').then((res) => {
          this.partners = res.data.filter((p) => {
            return partners.includes(p.id);
          });
        });
      }
    }
  },
  computed: {
    partnersTable() {
      return this.partners.map((pl) => {
        return {
          ...pl,
          level: `${this.$t('Level')} ${pl.level}`,
          percentage: `${parseFloat(pl?.reward?.percentage || 0) * 100}%` || '',
          calculation: pl?.reward?.calculation || ''
        };
      });
    },
    isLevel3() {
      return this.level == 3;
    }
  },
  watch: {
    level() {
      this.partners = [];
    }
  }
};
</script>

<style></style>
